import 'deepmerge';

var LoadingBubble = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['loading-bubble', _vm.isShow && 'show'],style:({
    width: _vm.size,
    height: _vm.size,
  })},[_c('span',{class:"blob left",style:({
      width: _vm.size,
      height: _vm.size,
    })}),_vm._v(" "),_c('span',{class:"blob right",style:({
      width: _vm.size,
      height: _vm.size,
    })})])},
staticRenderFns: [],
  name: 'LoadingBubble',
  props: {
    size: {
      type: String,
      default: '10px',
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  mounted() {
    this.isShow = true;
  },
};

function isHexColorCode(code) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(code);
}
function hexToRGBA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + "," + (opacity === undefined ? 1 : opacity) + ")";
    }
    else {
        return null;
    }
}

var ARSimpleButton = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'ar-simple-button',
    _vm.loading && 'loading',
    _vm.disabled ? 'disabled' : _vm.colorClassName,
    _vm.outlined && 'outlined',
    _vm.transparent && 'transparent',
    _vm.hasIcon && _vm.iconSide ],style:(_vm.customStyle),attrs:{"ar-widget-id":"ar-simple-button","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-simple-button"},on:{"click":_vm.handleButtonClick,"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}},[(_vm.hasIcon)?_c('ar-icon',_vm._b({staticClass:"icon",style:({
      marginRight: _vm.iconSide === 'left' ? _vm.iconDistance : 0,
      marginLeft: _vm.iconSide === 'right' ? _vm.iconDistance : 0,
    }),attrs:{"name":_vm.iconName}},'ar-icon',_vm.iconProps,false)):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-icon"},[_c('LoadingBubble',{staticClass:"loading-bubble"})],1):_c('ar-text',{staticClass:"text",attrs:{"size":"xs","text":_vm.text,"weight":_vm.textWeight,"direction":_vm.direction}})],1)},
staticRenderFns: [],
  name: 'SimpleButton',
  components: {
    LoadingBubble,
  },
  props: {
    arWidgetMeta: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: null,
    },
    textWeight: {
      type: String,
      default: 'bold',
    },
    iconName: {
      type: String,
      default: null,
    },
    iconDistance: {
      type: String,
      default: '5px',
    },
    iconSide: {
      type: String,
      default: 'left',
      validator: item =>
        ['left', 'right'].indexOf(item) > -1,
    },
    iconProps: {
      type: Object,
      default: () => ({
        height: '14px',
      }),
    },
    shape: {
      type: String,
      default: 'rounded-rectangle',
      validator: (value) =>
        ['rounded-rectangle', 'pill'].indexOf(value) !== -1,
    },
    type: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple', 'gradient-purple', 'grey', 'green', 'red', 'messenger', 'black'].indexOf(value) > -1 || isHexColorCode(value);
      },
    },
    customStyleAttributes: {
      type: Object,
      default: () => ({}),
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String || null,
      default: null,
      validator: (value) =>
        ['auto', 'ltr', 'rtl', null].indexOf(value) !== -1,
    },
  },
  data() {
    return {
      buttonHeight: 50,
      hovered: false,
    };
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `text=${this.text};`,
      ].join('');
    },
    hasIcon() {
      return !this.loading && !!this.iconName;
    },
    isCustomColor() {
      return isHexColorCode(this.type);
    },
    colorClassName() {
      return this.isCustomColor ? 'custom' : this.type;
    },
    customStyle() {
      const style = {
        color: this.isCustomColor ? this.type : null,
      };
      if (this.shape === 'pill') {
        // In this case, you can't change radius from outside.
        style.borderRadius = `${this.buttonHeight / 2}px`;
      }
      if (this.outlined && this.hovered && this.isCustomColor) {
        style.background = hexToRGBA(this.type, 0.1);
      }
      const mergedStyle = {...style, ...this.customStyleAttributes};
      return mergedStyle;
    },
  },
  mounted() {
    this.buttonHeight = this.$el.offsetHeight;
  },
  methods: {
    handleMouseEnter() {
      this.hovered = true;
    },
    handleMouseLeave() {
      this.hovered = false;
    },
    handleButtonClick(e) {
      e.stopPropagation();
      if (this.disabled || this.loading) {
        e.preventDefault();
        return;
      }
      this.$emit('click', e);
    },
  },
};

export default ARSimpleButton;
